import { DcBaseComponent } from '@deleteagency/dc';
import analyticsService from 'general/js/analytics-service';
import api from 'general/js/api';

const CLASS_ACTIVE = 'is-active';

export default class CovertValue extends DcBaseComponent {
    #currencyValues = null;

    #activeBtn = null;

    static getNamespace() {
        return 'convert-value';
    }

    static getRequiredRefs() {
        return ['values', 'btns'];
    }

    onInit() {
        this.#setCurrencyValue();
        this.#activeBtn = Object.values(this.refs.btns).find(el => el.classList.contains(CLASS_ACTIVE));
        this.refs.values.forEach((value) => {
            value.currentValue = value.getAttribute('data-value');
        });
        Object.keys(this.refs.btns).forEach((key) => {
            this.addListener(this.refs.btns[key], 'click', e => this.#onClick(e, key));
        });
    }

    #setCurrencyValue = () => {
        const day = new Date().getDay();
        if (sessionStorage.currencyValues) {
            const values = JSON.parse(sessionStorage.currencyValues);
            if (values.day === day) {
                this.#currencyValues = values;
                return;
            }
        }
        api.get(this.options.endpoint)
            .then((result) => {
                const data = result.data;
                data.day = day;
                sessionStorage.currencyValues = JSON.stringify(data);
                this.#currencyValues = data;
            })
            .catch((error) => {
                console.dir(error);
            });
    };

    #updateValues = (name) => {
        analyticsService.sendEvent('_trackEvent', 'Property Details', name);
        if (this.#currencyValues) {
            this.refs.values.forEach((value) => {
                value.innerHTML =
                    this.refs.btns[name].innerHTML +
                    Math.floor(
                        (+this.#currencyValues[name] || 1) * value.currentValue
                    ).toLocaleString();
            });
        } else {
            console.log('There is not got data yet');
        }
    };

    #toggleActiveBtn = (btn) => {
        if (this.#activeBtn) {
            this.#activeBtn.classList.remove(CLASS_ACTIVE);
        }
        btn.classList.add(CLASS_ACTIVE);
        this.#activeBtn = btn;
    };

    #onClick = (e, name) => {
        this.#updateValues(name);
        this.#toggleActiveBtn(this.refs.btns[name]);
    };
}
